import React from 'react';
import { DESIGN_THEMES } from '../../constants/designThemes';
import { useDesignTheme } from '../../context/DesignThemeContext';
import './SettingsPage.css';

export default function SettingsPage() {
  const { theme, setTheme } = useDesignTheme();

  return (
    <div className="settings-page">
      <div className="settings-page-header">
        <h2 className="settings-page-title">הגדרות</h2>
        <p className="settings-page-subtitle">התאמת מראה המערכת לפי העדפה</p>
      </div>

      <section className="settings-section" aria-labelledby="settings-design-title">
        <h3 id="settings-design-title" className="settings-section-title">סגנון עיצובי</h3>
        <p className="settings-section-desc">בחרי את סגנון התפריט והמראה הכללי של הפורטל</p>

        <ul className="settings-theme-list">
          {Object.values(DESIGN_THEMES).map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={`settings-theme-option${theme === item.id ? ' settings-theme-option--active' : ''}`}
                aria-pressed={theme === item.id}
                onClick={() => setTheme(item.id)}
              >
                <span className="settings-theme-option-label">{item.label}</span>
                <span className="settings-theme-option-desc">{item.description}</span>
              </button>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
